export const WELCOME_MESSAGES = [
  "Salut! Sunt Smartie 👋 Cum te pot ajuta cu marketingul?",
  "Ai întrebări despre growth hacking? Să vorbim! 🚀",
  "Vreau să-ți arăt cum să-ți crești afacerea. Hai să discutăm! 💡",
  "Strategia ta de marketing funcționează? Să analizăm împreună! 📈",
  "Ce provocări ai în marketing? Sunt aici să te ajut! 🎯",
];
